export const FINANCING_EDUCATION = {
  loanTerm: {
    title: 'Loan Term',
    text: '<p>The amount of time you have to repay the loan.The shorter the loan term the lower the overall project cost.</p>',
    loanTermOptions: [
      {
        unique_name: 'month24',
        name: '24 months',
        selected: true,
      },
      {
        unique_name: 'month60',
        name: '60 months',
        selected: false,
      },
    ],
  },
  downPayment: {
    title: 'Interest Rate',
    text: '<p>Interest rates can vary significantly across lenders and financing plans. The higher the rate, the higher the total cost.</p>',
    downPaymentOptions: [
      {
        unique_name: 'percent5',
        name: '5%',
        selected: true,
      },
      {
        unique_name: 'percent15',
        name: '15%',
        selected: false,
      },
    ],
  },
  logicMap: {
    initial_cost: '10,000',
    map: [
      {
        unique_names_combination: 'month24 percent5',
        value: '10,529.15',
      },
      {
        unique_names_combination: 'month60 percent5',
        value: '11,322.74',
      },
      {
        unique_names_combination: 'month24 percent15',
        value: '11,636.81',
      },
      {
        unique_names_combination: 'month60 percent15',
        value: '14,273.90',
      },
    ],
  },
};